/* global angular, rison, _ */

var ngModule = angular.module('trends');

ngModule.factory('QuerySerializer', ['$location',
    function ($location) {
        /* Ctor.
         *
         * `fields` is an object mapping field names to field options.
         * The options available to a field are `type`, `fallback` and `required`.
         *
         * If `wrapAs` is given, your fields are wrapped and stored in a single QS parameter.
         * Examples:
         *   with wrapAs = 'foo': '/myurl/?foo=fielda:2,fieldb:10'
         *   without wrapAs: '/myurl/?fielda=2&fieldb=10'
         *
         * This is useful if you're using multiple serializers (to avoid conflicts) or
         * just want to use less parameters.
         */
        function QuerySerializer(fields, wrapAs) {
            this.fields = fields;
            this.wrapAs = wrapAs || false;

            angular.forEach(this.fields, function (v) {
                v.fallback = v.fallback !== undefined ? v.fallback : null;
                v.required = v.required !== undefined ? v.required : true;
            });
        }

        // Encoding options
        QuerySerializer.T_OBJECT = 'object';
        QuerySerializer.T_ARRAY = 'array';
        QuerySerializer.T_STRING = 'string';
        QuerySerializer.T_NUMBER = 'number';

        /* we typically do not want to add any empty fields to the url as that
        contributes nothing, thus they should be stripped from the object. */
        var stripEmptyData = function(data) {
            // assume that data is an object
            var finalObj = {};
            var keys = Object.keys(data);
            for (var i=0; i < keys.length; i++) {
                var elem = data[keys[i]];
                if (elem !== null && !(angular.equals(elem, {})) && !(angular.equals(elem, []))) {
                    finalObj[keys[i]] = data[keys[i]];
                }
            }

            return finalObj;
        };

        /* Serialize object 'data' returning a query string */
        QuerySerializer.prototype.generate = function (data) {
            var that = this;
            var prepared = {};

            // Prepare the passed in data for serialization
            angular.forEach(data, function (v, k) {
                var encoded;
                var field = that.fields[k];

                if (angular.equals(v, field.fallback)) {
                    encoded = null; // Don't serialize
                } else {
                    switch (field.type) {
                    case QuerySerializer.T_OBJECT:
                        var data = stripEmptyData(v);
                        if (!angular.equals(data, {})) {
                            encoded = rison.encode_object(data);
                        }
                        else {
                            encoded = null;
                        }
                        break;
                    case QuerySerializer.T_ARRAY:
                        encoded = rison.encode_array(v); break;
                    default:
                         encoded = v;
                    }
                }
                prepared[k] = encoded;
            });

            if (this.wrapAs) {
                return rison.encode_object(prepared);
            }
            return prepared;
        };

        /* Serialize object `data` and save in the URL. */
        QuerySerializer.prototype.save = function (data) {
            var prepared = this.generate(data);

            // Store in the URL...
            if (this.wrapAs) {
                $location.search(this.wrapAs, prepared);
            } else {
                angular.forEach(this.fields, function (field, k) {
                    $location.search(k, prepared[k] || null); // Null removes the parameter
                });
            }
            $location.replace(); // ... without creating a new history record
        };

        /* Load saved state from the query string.
         *
         * Returns an object containing the saved state, or `false` if a required field
         * cannot be loaded. A field cannot be loaded if it is unparseable or missing.
         *
         * If a non-required field cannot be loaded, its `fallback` value is used instead.
         */
        QuerySerializer.prototype.load = function () {
            var that = this;
            var out = {};
            var qs = $location.search();
            var data;

            if (this.wrapAs) {
                data = qs[this.wrapAs] ? rison.decode_object(qs[this.wrapAs]) : {};
            } else {
                data = qs;
            }

            var keys = Object.keys(this.fields);

            for (var i = 0; i < keys.length; i++) {
                var k = keys[i];
                var field = this.fields[k];
                var decoded = undefined; // jshint ignore:line
                var rawValue = data[k];

                if (rawValue) {
                    try {
                        decoded = that.parseField(rawValue, field.type);
                    } catch (e) {
                        $location.search(k, null);
                        $location.replace();
                    }
                }

                if (decoded === undefined) {
                    if (field.required) {
                        return false;
                    } else {
                        decoded = field.fallback;
                    }
                }

                out[k] = decoded;
            }

            return out;
        };

        /* Clear the saved state (if any) for this serializer from the QS. */
        QuerySerializer.prototype.clearState = function () {
            if (this.wrapAs) {
                $location.search(this.wrapAs, null);
            } else {
                // `qs` is a direct reference, so the line after it works
                var qs = $location.search();
                _.omit(qs, function (k) { _.has(this.fields, k); });
            }

            $location.replace();
        };

        /* Attempt to parse `value` into `type`. Raises an exception on parse failure. */
        QuerySerializer.prototype.parseField = function (value, type) {
            var decoded;
            switch (type) {
            case QuerySerializer.T_OBJECT:
                decoded = rison.decode_object(value); break;
            case QuerySerializer.T_ARRAY:
                decoded = rison.decode_array(value); break;
            case QuerySerializer.T_NUMBER:
                decoded = parseInt(value, 10); break;
            case QuerySerializer.T_STRING:
                decoded = value; break;
            default:
                // TODO Throw exception
            }

            return decoded;
        };

        return QuerySerializer;
    }]);
